import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Solutionled(props) {
  return (
    <section
      className="solutionled p-100"
      style={{ backgroundColor: "#f8f8fb" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-2 order-md-1 mt-4 mt-md-0"
          >
            <StaticImage
              src="../../images/industries/fintech/innvoation-led.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={717}
              height={708}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto order-1 order-md-2"
          >
            <div className="example" data-text="Fintech App">
              <h2>An Innovation-Led Fintech Software Development Company</h2>
            </div>
            <p>
              Our FinTech Software Development services are dedicated to
              producing flawlessly integrated high-level solutions that are
              customized to your business needs.
            </p>
            <p>
              As a trusted Fintech software development company, we’re committed
              to providing custom solutions that drive innovation and growth.
            </p>
            <p>
              Whether it's flawless payment systems or advanced financial
              analytics, our FinTech solutions are both efficient and precise.
              To ensure that your business processes are optimized for best
              performance, our FinTech software developers deliver innovative
              technology that not only meets but beyond industry standards.
            </p>
            <div className="btn_talk">
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionled;
